// extracted by mini-css-extract-plugin
module.exports = {"container":"status-icon_container__3X8iO","icon":"status-icon_icon__3Utge"};